import { useEffect, useState, useRef } from "react";
import { Helmet } from 'react-helmet-async'
import { CorpHeader } from '../../common/corp-header'
import { CorpFooter } from '../../common/corp-footer'
import axios from "axios";
import './email-verify.css'

let constRequested = false;

interface FnsError {
  errorCode: string;
  errorMessage: string;
}

export const VerifyMail = () => {
  const [footerRect, setFooterRect] = useState<DOMRect>()
  const [verify, setVerify] = useState<boolean>();
  const [error, setError] = useState<FnsError>();
  const ftr = useRef<HTMLElement>(null)

  // codeの取得
  const search = global.location.search;
  const codeExec = /code=([^&]+)/.exec(search);

  const code = codeExec ? codeExec[1] : null;

  useEffect(() => {
    if (verify === void 0 && !constRequested) {
      constRequested = true;
      axios
        .post("/api/v1/sp/accounts/email/verify", { code })
        .then((result) => setVerify(true))
        .catch((error) => {
          console.error("errorあり", error);
          setError({
            errorCode: void 0,
            errorMessage: "不明なエラー",
            ...error,
          });
        });
    }
  });

    // フッタのサイズを監視
    useEffect(() => {
      setFooterRect(ftr?.current?.getBoundingClientRect())
    }, [ftr])
  return (
    <>
      <div className="contact">
        <div className="bodywrap">
          <Helmet title="メールアドレス検証 | Family Works" />
          <CorpHeader />
          {/* [アプリを開く]とフッタ-の間にスペースをあけるために+20する */}
          <main className="wrapper" style={{ paddingBottom: `${(footerRect?.height || 400) + 20}px` }}>
            {/* メール検証中 */}
            {!error && !verify && <section className="verify__section">
              <h2>メール検証中・・・</h2>
              <p>お待ち下さい。</p>
            </section>}
            {/* 登録成功の場合 */}
            {verify === true && <section className="verify__section">
              <h2>メールアドレス登録の完了</h2>
              <p>ファミリー ネットワーク サービスへのメールアドレスの登録が完了しました。</p>
              <ul>
                <li>「HELPO」の登録・連携ができるようになりました。</li>
                <li>いざという時の連絡先として、本アプリを通じて、ご家族に共有いただくことが可能です。</li>
                <li>お困りの場合があれば、今後こちらのメールアドレスにご案内いたします。</li>
              </ul>
              <p>変更したい場合は、[メニュー]→[プロフィール]にて編集ください。</p>
              <a className="verify__cta" href="https://familynetwork.page.link/nf9s">アプリを開く</a>
            </section>}
            {/* 登録失敗の場合 */}
            {error && <section className="verify__section">
              <h2 className="verify__h2_err">メールアドレス登録の失敗</h2>
              <p>ファミリー ネットワーク サービスへのメールアドレスの登録に失敗しました。URLが間違っているか、URLの有効期限が終わっているようです。</p>
              <p>再度アプリよりメールアドレスの登録をお願いいたします。</p>
              <a className="verify__cta" href="https://familynetwork.page.link/nf9s">アプリを開く</a>
            </section>}
          </main>

          <CorpFooter ref={ftr} />

        </div>
      </div>
    </>
  );
};
